export const namespaced = true

export const state = {
  mapCenter: { lat: 13.862479, lng: 100.533433 },
  markers: [],
  markersInit: []
}

export const mutations = {
  SET_MAP_CENTER(state, mapCenter) {
    state.mapCenter = mapCenter
  },
  SET_MARKERS(state, markers) {
    state.markers = markers
  },
  SET_MARKERS_INIT(state, markersInit) {
    state.markersInit = markersInit
  }
}
